import { render, staticRenderFns } from "./AlltestaTowerSettings.vue?vue&type=template&id=92f12890&scoped=true&"
import script from "./AlltestaTowerSettings.vue?vue&type=script&lang=js&"
export * from "./AlltestaTowerSettings.vue?vue&type=script&lang=js&"
import style0 from "./AlltestaTowerSettings.vue?vue&type=style&index=0&id=92f12890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f12890",
  null
  
)

export default component.exports